"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _InputGroup = _interopRequireDefault(require("./InputGroup"));

var _ResultList = _interopRequireDefault(require("./ResultList"));

var _HiddenInput = _interopRequireDefault(require("./HiddenInput"));

var _getOptionProperties = require("./getOptionProperties");

var _createFilter = _interopRequireDefault(require("./createFilter"));

var _excluded = ["name", "required", "optional", "multiSelect", "async", "selectedOptions", "onClear", "placeholder", "getOptionLabel", "getOptionValue", "icon", "action", "onChange", "options", "filter", "value", "optionRenderer", "noResultsMessage", "label", "labelElement", "hideLabel", "error", "warning", "info", "disabled", "className", "validationFirst", "element", "spellcheck", "getInputProps", "getItemProps", "getMenuProps", "isOpen", "inputValue", "highlightedIndex", "selectedItem", "getToggleButtonProps", "clearSelection"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var AutocompleteFormGroup = function AutocompleteFormGroup(_ref) {
  var name = _ref.name,
      required = _ref.required,
      optional = _ref.optional,
      multiSelect = _ref.multiSelect,
      async = _ref.async,
      selectedOptions = _ref.selectedOptions,
      onClear = _ref.onClear,
      placeholder = _ref.placeholder,
      getOptionLabel = _ref.getOptionLabel,
      getOptionValue = _ref.getOptionValue,
      icon = _ref.icon,
      action = _ref.action,
      onChange = _ref.onChange,
      options = _ref.options,
      filter = _ref.filter,
      value = _ref.value,
      optionRenderer = _ref.optionRenderer,
      noResultsMessage = _ref.noResultsMessage,
      label = _ref.label,
      labelElement = _ref.labelElement,
      hideLabel = _ref.hideLabel,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      disabled = _ref.disabled,
      className = _ref.className,
      validationFirst = _ref.validationFirst,
      element = _ref.element,
      spellcheck = _ref.spellcheck,
      getInputProps = _ref.getInputProps,
      getItemProps = _ref.getItemProps,
      getMenuProps = _ref.getMenuProps,
      isOpen = _ref.isOpen,
      inputValue = _ref.inputValue,
      highlightedIndex = _ref.highlightedIndex,
      selectedItem = _ref.selectedItem,
      getToggleButtonProps = _ref.getToggleButtonProps,
      clearSelection = _ref.clearSelection,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    labelElement: labelElement,
    name: name,
    required: required,
    optional: optional,
    label: label,
    hideLabel: hideLabel,
    error: error,
    warning: warning,
    info: info,
    className: className,
    validationFirst: validationFirst,
    element: element
  }, function (inputProps) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_HiddenInput.default, {
      name: name,
      multiSelect: multiSelect,
      value: multiSelect ? selectedOptions.map(function (option) {
        return getOptionValue(option);
      }) : getOptionValue(selectedItem)
    }), /*#__PURE__*/_react.default.createElement(_InputGroup.default, _extends({}, inputProps, {
      getInputProps: getInputProps,
      getToggleButtonProps: getToggleButtonProps,
      getClearButtonProps: function getClearButtonProps(props) {
        return Object.assign({
          onClick: onClear || clearSelection,
          'aria-label': 'Clear the field'
        }, props);
      },
      selectedOption: !multiSelect ? selectedItem : undefined,
      selectedOptions: selectedOptions,
      isOpen: isOpen,
      optional: optional,
      placeholder: placeholder,
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      icon: icon,
      action: action,
      onChange: onChange,
      hideInput: !async && options.length === 0,
      disabled: disabled,
      spellCheck: spellcheck,
      name: name
    }, rest)), /*#__PURE__*/_react.default.createElement(_ResultList.default, {
      getMenuProps: getMenuProps,
      getItemProps: getItemProps,
      selectedItem: selectedItem,
      isOpen: isOpen,
      highlightedIndex: highlightedIndex,
      options: options.filter(filter(value || inputValue, getOptionLabel)),
      optionRenderer: optionRenderer,
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      noResultsMessage: noResultsMessage
    }));
  });
};

AutocompleteFormGroup.propTypes = Object.assign({}, _form.FormGroup.propTypes, {
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  onChange: _propTypes.default.func,
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  optionRenderer: _propTypes.default.func,
  hideLabel: _propTypes.default.bool,
  required: _propTypes.default.bool,
  optional: _propTypes.default.bool,
  info: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  getOptionLabel: _propTypes.default.func,
  getOptionValue: _propTypes.default.func,
  filter: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  icon: _propTypes.default.node,
  action: _propTypes.default.bool,
  multiSelect: _propTypes.default.bool,
  async: _propTypes.default.bool,
  value: _propTypes.default.string,
  selectedOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  onClear: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  spellcheck: _propTypes.default.bool,
  getInputProps: _propTypes.default.func.isRequired,
  getItemProps: _propTypes.default.func.isRequired,
  getMenuProps: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool,
  inputValue: _propTypes.default.string,
  highlightedIndex: _propTypes.default.number,
  selectedItem: _propTypes.default.shape({}),
  getToggleButtonProps: _propTypes.default.func.isRequired,
  clearSelection: _propTypes.default.func.isRequired
});
AutocompleteFormGroup.defaultProps = {
  options: [],
  onChange: undefined,
  optionRenderer: undefined,
  hideLabel: false,
  required: undefined,
  optional: undefined,
  info: undefined,
  disabled: false,
  getOptionLabel: _getOptionProperties.getOptionLabel,
  getOptionValue: _getOptionProperties.getOptionValue,
  filter: _createFilter.default,
  placeholder: undefined,
  icon: undefined,
  action: undefined,
  multiSelect: false,
  async: false,
  value: undefined,
  selectedOptions: [],
  onClear: undefined,
  onSelect: undefined,
  isOpen: false,
  inputValue: undefined,
  highlightedIndex: undefined,
  selectedItem: undefined,
  spellcheck: false
};
AutocompleteFormGroup.displayName = 'AutocompleteFormGroup';
var _default = AutocompleteFormGroup;
exports.default = _default;